// Custom engraving options
// @see https://support.maestrooo.com/article/304-technical-javascript-events-exposed-by-the-theme
// % prettier assets/agmes-engraving-options.js --write --single-quote

var agmesEngravingOptions = null;

function agmesEngravingInit() {
  console.log('Engraving options init');

  if (agmesEngravingOptions.querySelector('script')) {
    var currentVariant = JSON.parse(agmesEngravingOptions.querySelector('script').textContent);
    agmesEngravingToggle(agmesEngravingSelected(currentVariant));
  }

  var engravingTextInput = document.querySelector('.input__engraving-options-text');
  if (engravingTextInput) {
    engravingTextInput.addEventListener('input', () => {
      console.log('engravingTextInput input event');
      engravingTextInput.setCustomValidity('');

      if (engravingTextInput.checkValidity() === false) {
        engravingTextInput.setCustomValidity('Please provide engraving text.');
      }
    });

    engravingTextInput.addEventListener('invalid', () => {
      engravingTextInput.setCustomValidity('Please provide engraving text.');
    });
  }

  agmesEngravingOptions.querySelectorAll('input[type=radio]').forEach(function (element) {
    element.addEventListener('change', function (event) {
      if (element.checked) {
        var textInput = agmesEngravingOptions.querySelector('.input__engraving-options-text');
        textInput.classList.remove('cursive', 'sans', 'script');
        textInput.classList.add(element.value.toLowerCase());
      }
    });
  });
}

function agmesEngravingSelected(variant) {
  var options = {
    'Without Engraving': false,
    'With Engraving': true,
  };

  for (var option in options) {
    var optionMatch = false;

    variant.options.forEach(function (element) {
      if (element.includes(option)) {
        optionMatch = option;
      }
    });

    if (optionMatch) {
      return options[optionMatch];
    }
  }

  return false;
}

function agmesEngravingToggle(show) {
  console.log('agmesEngravingToggle', show);

  if (show) {
    agmesEngravingOptions.style.display = 'block';
    agmesEngravingOptions.querySelectorAll('input').forEach(function (element) {
      element.disabled = false;
    });

    return;
  }

  agmesEngravingOptions.style.display = 'none';
  agmesEngravingOptions.querySelectorAll('input').forEach(function (element) {
    element.disabled = true;
  });
}

agmesEngravingOptions = document.querySelector('.engraving-options');
if (agmesEngravingOptions) {
  agmesEngravingInit();
}
